module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', _vm._b({
    staticClass: "ds-calendar-event-menu",
    attrs: {
      "content-class": _vm.contentClass,
      "disabled": !_vm.hasPopover
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, 'v-menu', _vm.popoverProps, false), [_c('ds-calendar-event', _vm._b({
    attrs: {
      "slot": "activator",
      "is-placeholder-with-day": _vm.day,
      "calendar-event": _vm.placeholder,
      "calendar": _vm.calendar,
      "index": _vm.index
    },
    slot: "activator"
  }, 'ds-calendar-event', {
    $scopedSlots: _vm.$scopedSlots
  }, false)), _vm._v(" "), _vm._t("eventCreatePopover", null, null, {
    placeholder: _vm.placeholder,
    calendar: _vm.calendar,
    day: _vm.day,
    index: _vm.index,
    close: _vm.close
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26705f1f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalendarEventPlaceholder.vue
// module id = 160
// module chunks = 0